import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_BANK_LIST_API_ID = 'INVESTCORE/FETCH_BANK_LIST_API';

const apiCall = createApiCall(FETCH_BANK_LIST_API_ID, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/banks`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
